<template>
  <vc-date-picker ref="datePicker"
                  mode="range"
                  v-model="value"
                  :popover="{visibility: 'click'}"
                  :min-date='new Date().setDate(new Date().getDate() - 1)'>
    <v-text-field slot-scope="{ isDragging }"
                  :class="['date-range-input', {'input-icon': !!datePickerStartDate}]"
                  v-model="datePickerInputText"
                  readonly
                  placeholder="Pick a date range"
                  style="width:15em">
      <template v-slot:prepend>
        <v-icon>calendar_today</v-icon>
        <span style="display:none">{{datePickerDrag = isDragging}}</span>
      </template>
      <template v-slot:prepend-inner>
        {{ datePickerStartDate ? format(datePickerStartDate) : ""}}
      </template>
      <template v-slot:append>
        <v-btn v-if="isDragging" small color="accent" style="margin-top:-4px;width:85px;" @click.prevent.stop="datePickerEndless()">
          Onward
        </v-btn>
        <span v-else-if="value.end">
          {{ value.end ? format(value.end) : ""}}
        </span>
        <span v-else-if="datePickerStartDate" style="width:85px;text-align:center">
          Onward
        </span>
      </template>
    </v-text-field>
  </vc-date-picker>
</template>
<script>
  import moment from 'moment';
  const locale = window.navigator.userLanguage || window.navigator.language;

  export default {
    props: {
      value: Object
    },
    data() {
      return {
        datePickerStartDate: null,
        datePickerIsDraggingLastTick: null,
      }
    },
    computed: {
      datePickerDrag: {
        get() { },
        set(v) {
          if (v !== this.datePickerIsDraggingLastTick)
            this.datePickerStartDate = (this.$refs.datePicker && this.$refs.datePicker.dragValue && this.$refs.datePicker.dragValue.start) || (this.value && this.value.start) || null
          this.datePickerIsDraggingLastTick = v;
        }
      },
      datePickerInputText() {
        return this.datePickerStartDate ? "chevron_right" : null;
      }
    },
    methods: {
      init() {
        this.datePickerStartDate = null;
        this.datePickerIsDraggingLastTick = null;

      },
      datePickerEndless() {
        this.$refs.datePicker.picker.handleDayClick({ dateTime: this.datePickerStartDate }, this.$refs.datePicker)
        window.requestAnimationFrame(() => {
          this.value.start = this.datePickerStartDate;
          this.value.end = null;
        });

      },
      format(time) {
        return moment(time).format('L');
      }
    },
    created() {
      moment.locale(locale);
    }
  }
</script>
<style scoped>
   >>>.date-range-input input {
    text-align: center;
    line-height: 1.5;
    padding-bottom: 4px;
  }
  >>>.date-range-input.input-icon input {
    font-family: 'Material Icons';
    font-size: 1.5em;
    padding-top: 0;
    padding-bottom: 8px;
    letter-spacing: normal;
    text-transform: none;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }
</style>